// extracted by mini-css-extract-plugin
module.exports = {"sea":"SearchBar_sea__3pL6l","search":"SearchBar_search__22_iH","btn":"SearchBar_btn__1y13w"};